// UI-CRITICAL: Do not modify text structure without checking SEO impact.
// This file is the single source of truth for all user-facing copy.
// Components import from here — never hardcode critical strings in JSX.

// ── Hero Section ──────────────────────────────────────────────────────────
export const hero = {
  greeting: 'Hi, my name is',
  name: 'Biruk Kasahun.',
  subtitle: 'I build scalable backend systems and cloud infrastructure.',
  description:
    "I'm a Software Engineer specializing in backend development, AWS cloud " +
    'architecture, and infrastructure as code with Terraform. I focus on ' +
    'building secure APIs, distributed services, and reliable ' +
    'production-ready systems.',
  cta: 'Get In Touch',
};

// ── About Section ─────────────────────────────────────────────────────────
export const about = {
  heading: 'About Me',
  paragraphs: [
    "I'm a backend-focused software engineer who designs reliable systems and scalable cloud infrastructure. I specialize in secure APIs, distributed services, and production-ready applications.",
    'My primary stack includes Python, Django, and PostgreSQL for backend development, with AWS and Terraform for cloud automation. I enjoy building maintainable, resilient systems that scale in real-world environments.',
    "I'm particularly interested in backend architecture, distributed systems, and cloud-native development. Recently I've been working on projects involving infrastructure automation, scalable web applications, and backend system design.",
  ],
  closingHtml:
    'Feel free to explore my <a href="https://github.com/brook1717?tab=repositories" target="_blank" rel="noreferrer">GitHub projects</a> or <a href="mailto:brookkasahun@gmail.com" target="_blank" rel="noreferrer">reach out</a> if you\'d like to collaborate.',
};

// ── Contact Section ───────────────────────────────────────────────────────
export const contact = {
  overline: "What's Next?",
  heading: 'Get In Touch',
  description:
    "I'm currently open to backend and cloud engineering opportunities. " +
    "If you're building scalable systems or interesting infrastructure, " +
    "I'd love to connect and discuss how I can contribute.",
  cta: 'Say Hello',
};

// ── SEO / Metadata ────────────────────────────────────────────────────────
export const meta = {
  title: 'Biruk Kasahun | Software Engineer',
  description:
    'Biruk Kasahun is a Software Engineer specializing in backend development, ' +
    'AWS cloud architecture, and scalable infrastructure. Building robust ' +
    'automated systems and distributed services.',
  siteUrl: 'https://birukkasahun.com',
  image: '/og.png',
  twitterUsername: '@birukksahun',
  personName: 'Biruk Kasahun',
  jobTitle: 'Software Engineer',
};
